export const formatDate = (dateString) => {
  if (!dateString) return 'N/A'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const formatTimeAgo = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)

  if (seconds < 60) return 'Just now'

  const intervals = [
    { label: 'year', secs: 31536000 },
    { label: 'month', secs: 2592000 },
    { label: 'day', secs: 86400 },
    { label: 'hour', secs: 3600 },
    { label: 'minute', secs: 60 },
  ]

  for (const { label, secs } of intervals) {
    const count = Math.floor(seconds / secs)
    if (count >= 1) return `${count} ${label}${count > 1 ? 's' : ''} ago`
  }

  return 'Just now'
}

export const formatPercentage = (value) => {
  return `${Math.round(value)}%`
}

export const formatNumber = (value) => {
  return new Intl.NumberFormat('en-US').format(value)
}

export const getViolationImpactColor = (impact) => {
  const colors = {
    critical: 'text-red-600 bg-red-50 border-red-200',
    serious: 'text-orange-600 bg-orange-50 border-orange-200',
    moderate: 'text-yellow-600 bg-yellow-50 border-yellow-200',
    minor: 'text-blue-600 bg-blue-50 border-blue-200',
  }
  return colors[impact?.toLowerCase()] || colors.minor
}

export const truncateText = (text, maxLength = 100) => {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}
